import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SubscribeFlowPage } from '@/modules/subscriptions/pages/SubscribeFlowPage';

const wizardSearchSchema = z.object({
  step: z.enum(['product', 'plan', 'review', 'payment', 'success']).optional(),
  product_id: z.string().uuid().optional(),
  plan_id: z.string().uuid().optional(),
  subscription_id: z.string().uuid().optional(),
  checkout_session: z.string().uuid().optional(),
});

export const Route = createFileRoute('/dashboard/subscriptions/new')({
  validateSearch: (search) => wizardSearchSchema.parse(search),
  component: SubscribeFlowPageRoute,
});

function SubscribeFlowPageRoute() {
  const search = Route.useSearch();
  return <SubscribeFlowPage search={search} />;
}
